<template>
  <a-drawer
    title="合并订单详情"
    placement="right"
    :width="800"
    :visible="visible"
    @close="close"
    destroyOnClose
  >
    <a-descriptions :column="2" bordered v-if="detailData">
      <a-descriptions-item label="ID" :span="1">{{ detailData.id }}</a-descriptions-item>
      <a-descriptions-item label="状态" :span="1">
        <a-tag :color="getStateColor(detailData.state)">{{ getStateText(detailData.state) }}</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="订单号" :span="1">{{ detailData.orderNo || '-' }}</a-descriptions-item>
      <a-descriptions-item label="订单标识" :span="1">{{ detailData.orderId || '-' }}</a-descriptions-item>
      <a-descriptions-item label="订单产品" :span="2">{{ detailData.orderProd || '-' }}</a-descriptions-item>
      <a-descriptions-item label="需合并订单号" :span="1">{{ detailData.mergeOrderNo || '-' }}</a-descriptions-item>
      <a-descriptions-item label="需合并订单标识" :span="1">{{ detailData.mergeOrderId || '-' }}</a-descriptions-item>
      <a-descriptions-item label="需合并订单产品" :span="2">{{ detailData.mergeOrderProd || '-' }}</a-descriptions-item>
      <a-descriptions-item label="维修师傅" :span="1">{{ detailData.userName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="维修师傅电话" :span="1">{{ detailData.userPhone || '-' }}</a-descriptions-item>
      <a-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</a-descriptions-item>
      <a-descriptions-item label="插入时间" :span="1">{{ parseTime(detailData.createTime) }}</a-descriptions-item>
      <a-descriptions-item label="自动失效时间" :span="1">{{ parseTime(detailData.loseEfficacyTime) }}</a-descriptions-item>
    </a-descriptions>
    <a-spin :spinning="loading" style="text-align: center; padding: 50px 0" v-else />
  </a-drawer>
</template>

<script>
import { getObj } from '@/api/maintenance/orderMerge/index'
import { parseTime as formatTime } from '@/utils/ruoyi'

export default {
  name: 'MergeDetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: null
    }
  },
  methods: {
    open(record) {
      this.visible = true
      this.loading = true
      getObj(record.id)
        .then((response) => {
          if (response.code === '20001' && response.data) {
            this.detailData = response.data
          } else {
            this.$message.error('获取详情失败')
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message.error('获取详情失败')
        })
    },
    close() {
      this.visible = false
      this.detailData = null
    },
    getStateText(state) {
      const stateMap = {
        0: '等待确认',
        1: '确认合并',
        2: '否合并订单',
        3: '超时取消合并'
      }
      return stateMap[state] || '-'
    },
    getStateColor(state) {
      const colorMap = {
        0: 'orange',
        1: 'green',
        2: 'red',
        3: 'gray'
      }
      return colorMap[state] || 'default'
    },
    parseTime(time) {
      if (!time) return '-'
      return formatTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
}
</script>

